/* === UPDATED FILE: src/pages/courses/LiveCourseDetailPage.js === */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const LiveCourseDetailPage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    const [course, setCourse] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    // --- NEW STATE --- to track if the current user is registered
    const [isRegistered, setIsRegistered] = useState(false);

    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            const token = localStorage.getItem('app_token');

            try {
                // Fetch the main course details (public)
                const courseRes = await axios.get(`/api/live-courses/${courseId}`);
                setCourse(courseRes.data);

                // --- NEW LOGIC ---
                // If the user is logged in, check their registration status
                if (token) {
                    const statusRes = await axios.get(
                        `/api/live-courses/${courseId}/registration-status`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    );
                    setIsRegistered(statusRes.data.isRegistered);
                }

            } catch (err) {
                setError('Could not load course details.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchCourseDetails();
    }, [courseId]);
    
    const handleRegisterClick = () => {
        const token = localStorage.getItem('app_token');
        if (!token) {
            navigate('/login', { state: { from: `/live-courses/${courseId}/payment` } });
        } else {
            navigate(`/live-courses/${courseId}/payment`);
        }
    };

    // --- NEW LOGIC --- for the main action button
    const renderActionButton = () => {
        if (isRegistered) {
            return (
                <a 
                    href={course.meeting_link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn-primary" 
                    style={{padding: '1rem 2rem', fontSize: '1.2rem', textDecoration: 'none', backgroundColor: '#27ae60'}}
                >
                    Go to Meeting
                </a>
            );
        } else {
            return (
                <button onClick={handleRegisterClick} className="btn-primary" style={{padding: '1rem 2rem', fontSize: '1.2rem'}}>
                    Sign Up Now for ₹{parseFloat(course.price).toFixed(2)}
                </button>
            );
        }
    };

    if (isLoading) return <p>Loading course details...</p>;
    if (error) return <p className="error-message">{error}</p>;
    if (!course) return <p>This course could not be found.</p>;

    return (
        <div className="article-detail-page" style={{padding: '1.5rem'}}>
            {course.intro_video_url && (
                 <div className="video-player-wrapper">
                    <video src={course.intro_video_url} className="video-element" controls>
                        Your browser does not support the video tag.
                    </video>
                </div>
            )}
            <h1 className="article-main-title">{course.title}</h1>
            <div className="course-meta" style={{justifyContent: 'flex-start', margin: '1.5rem 0'}}>
                <div className="meta-item"><span className="material-icons">event</span><span>Starts: {new Date(course.start_datetime).toLocaleString()}</span></div>
                <div className="meta-item"><span className="material-icons">schedule</span><span>{course.schedule_summary}</span></div>
                <div className="meta-item"><span className="material-icons">hourglass_empty</span><span>{course.duration}</span></div>
            </div>
            
            <div className="article-text-content" dangerouslySetInnerHTML={{ __html: course.summary }} />
            
            <div className="article-summary" style={{marginTop: '2rem'}}>
                <h3 className="summary-title">What You Will Learn</h3>
                <div className="summary-list" dangerouslySetInnerHTML={{ __html: course.learning_outcomes }} />
            </div>

            <div style={{marginTop: '2rem', textAlign: 'center'}}>
                 {renderActionButton()}
            </div>
        </div>
    );
};

export default LiveCourseDetailPage;
